import React from "react";
import { Form } from "react-bootstrap";
import "./Step4.css";

function Step4({ next, back, setObstacle, obstacle }) {
 
  return (
    <div className="step4_main">
      <h2 className="step_title">
        Just Answer <span>4</span> Simple questions to become a <br />
        <strong>Profcyma Partner</strong>
        <p></p>
      </h2>

      <p className="step_subtitle">
        What is the most significant obstacle you face in maintaining steady
        student enrollment?
      </p>

      <div className="form_holder">
        <div className="field_holder">
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Write here..."
            value={obstacle}
            onChange={(e) => setObstacle(e.target.value)}
          />
        </div>
      </div>

      <div className="step_btns">
        <button onClick={back} className="back_btn">
          Back
        </button>
        <button onClick={next} className="next_btn">
          Next
        </button>
      </div>
    </div>
  );
}

export default Step4;
